/**
 * 텍스트를 지정된 길이로 자르고 말줄임표(...) 추가
 * @param {string|number|null|undefined} text - 자를 텍스트
 * @param {number} maxLength - 최대 길이
 * @returns {string} 잘린 텍스트
 */
export const truncateText = (text, maxLength) => {
	if (text === null || text === undefined) {
		return ''
	}
	const str = String(text) // 숫자가 들어올 수도 있으므로 문자열로 변환
	if (str.length > maxLength) {
		return str.substring(0, maxLength) + '...'
	}
	return str
}
